import React from 'react';
import { DollarSign, FileText } from 'lucide-react';

const AdditionalFeesSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-amber-50 dark:bg-amber-900/20 p-4 rounded-lg border border-amber-200 dark:border-amber-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <DollarSign className="w-5 h-5 mr-2 text-amber-500" />
        Дополнительные сборы
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Регистрационный сбор */}
        <div>
          <label htmlFor="registrationFee" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Регистрационный сбор
          </label>
          <input
            type="text"
            id="registrationFee"
            name="registrationFee"
            value={formData.registrationFee}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.registrationFee ? 'input-error' : ''}`}
            placeholder="Введите сумму"
          />
          {errors.registrationFee && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.registrationFee}
            </p>
          )}
        </div>

        {/* Дополнительные услуги */}
        <div>
          <label htmlFor="additionalServices" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Дополнительные услуги
          </label>
          <input
            type="text"
            id="additionalServices"
            name="additionalServices"
            value={formData.additionalServices}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.additionalServices ? 'input-error' : ''}`}
            placeholder="Введите сумму"
          />
          {errors.additionalServices && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.additionalServices}
            </p>
          )}
        </div>
      </div>

      {/* Информационный блок о дополнительных сборах */}
      <div className="mt-4 bg-amber-100 dark:bg-amber-900/30 p-3 rounded-lg border border-amber-200 dark:border-amber-800">
        <div className="flex items-start">
          <FileText className="w-5 h-5 text-amber-600 dark:text-amber-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-amber-700 dark:text-amber-300 mb-1">
              О дополнительных расходах
            </h4>
            <p className="text-xs text-amber-600 dark:text-amber-400">
              Учитывайте все дополнительные расходы при оформлении автокредита. К ним относятся 
              регистрационный сбор ГИБДД, услуги оценщика, нотариуса, плата за электронный ПТС, 
              банковские комиссии и другие сопутствующие расходы, которые могут существенно 
              увеличить фактическую стоимость кредита.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdditionalFeesSection;